import { render, staticRenderFns } from "./MatchingLocations.vue?vue&type=template&id=657f33fe&"
import script from "./MatchingLocations.vue?vue&type=script&lang=ts&"
export * from "./MatchingLocations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports